<script setup lang="tsx">
import { ref, onUnmounted, onMounted, inject } from "vue";
import {
  useScroll$,
  getVerticalScrollTopPercentInPage,
  Context
} from "@zyzgroup/core-web";
import ProgressBar from "./ProgressBar.vue";

// for merge ce shadow-root styles
defineOptions({
  customOptions: { ProgressBar },
  inheritAttrs: true
});

const props = withDefaults(
  defineProps<{
    bgColor?: string;
    progressColor?: string;
    borderColor?: string;
    borderRadius?: string;
    showText?: boolean;
  }>(),
  {
    bgColor: "#efefef",
    progressColor: "#07B56D",
    borderColor: "transparent",
    borderRadius: "4px",
    showText: false
  }
);

const emits = defineEmits<{
  (event: "progress", percent: number): void;
}>();

const bar = ref();

function set() {
  const percent = getVerticalScrollTopPercentInPage();
  emits("progress", percent);
  bar.value?.goto(percent);
}

const subscription = useScroll$().subscribe((e) => {
  set();
});

// ce 中 编译-运行 失败
// const context = inject<Context>("context");
// context.eb.on("globalResize", () => {
//   set();
// });

onMounted(() => {
  set();
});

onUnmounted(() => {
  subscription.unsubscribe();
});

defineExpose({});
</script>

<template>
  <div class="page-vertical-scroll-progress-bar">
    <ProgressBar
      ref="bar"
      :bgColor="props.bgColor"
      :progressColor="props.progressColor"
      :borderColor="props.borderColor"
      :borderRadius="props.borderRadius"
      :showText="props.showText"
    ></ProgressBar>
  </div>
</template>

<style scoped>
.page-vertical-scroll-progress-bar {
  position: relative;
  overflow: hidden;
  width: 100%;
  height: 100%;
}
</style>
